/** * * Asynchronously loads the component for
MultiNetworkSelection
* */ import { lazyLoad } from "utils/loadable";
export const MultiNetworkSelection = lazyLoad(
  () => import("./index"),
  (module) => module.MultiNetworkSelection
);
